import React, { useState, useEffect, useRef, RefObject } from "react";
import { Outlet, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Layout.module.css";

import { useLogin } from "../../authConfig";

import { LoginButton } from "../../components/LoginButton";
import { Button } from "@fluentui/react-components";
import { Navigation24Regular } from "@fluentui/react-icons";
import { Disclaimer } from "../../components/Disclaimer";

import Logo from "../../assets/powered_by_hwh.svg?react";

const Layout = () => {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [disclaimerVisible, setDisclaimerVisible] = useState(false);
    const menuRef: RefObject<HTMLDivElement | null> = useRef(null);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleDisclaimerClose = () => {
        setDisclaimerVisible(false);
        // Store the user's preference to not show the disclaimer again
        localStorage.setItem("disclaimerDismissed", "true");
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setMenuOpen(false);
        }
    };

    useEffect(() => {
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    useEffect(() => {
        // Check if disclaimer was previously dismissed
        const disclaimerDismissed = localStorage.getItem("disclaimerDismissed");
        if (!disclaimerDismissed) {
            setDisclaimerVisible(true);
        }
    }, []);

    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer} ref={menuRef}>
                    <Link to="/" className={styles.headerTitleContainer}>
                        <Logo className={styles.logo} />
                        <h3 className={styles.headerTitle}>{t("headerTitle")}</h3>
                    </Link>
                    <div className={styles.loginMenuContainer}>
                        {useLogin && <LoginButton />}
                        <Button
                            appearance="subtle"
                            icon={<Navigation24Regular />}
                            className={styles.menuToggle}
                            onClick={toggleMenu}
                            aria-label={t("labels.toggleMenu")}
                        />
                    </div>
                </div>
            </header>

            <Disclaimer
                className={styles.layoutDisclaimer}
                fullDisclaimerUrl="https://www.stowa.nl/disclaimer"
                isVisible={disclaimerVisible}
                onClose={handleDisclaimerClose}
            />

            <Outlet />
        </div>
    );
};

export default Layout;
